export default "/images/vendor/flag-icon-css/flags/1x1/ba.svg?d1e732dc96724fe02492edb7e025a9d9";